import React from "react";
import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1758518730083-4c12527b6742?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB0ZWFtJTIwbWVldGluZyUyMG9mZmljZXxlbnwwfHx8fDE3ODE1NTk2MDJ8MA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <motion.img
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            src={ABOUT_IMG}
            alt="Professional team meeting"
            className="w-full h-[420px] md:h-[560px] object-cover"
            data-testid="about-image"
          />
        </div>

        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="overline mb-5">
            <span className="divider-gold mr-3" /> About the Firm
          </div>

          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7 }}
            className="font-serif text-[#111814] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            data-testid="about-heading"
          >
            A practice built on{" "}
            <em className="italic text-[#1A2F24]">trust</em>, sharpened by
            decades of meticulous craft.
          </motion.h2>

          <p className="mt-8 text-[#3A453F] text-lg leading-relaxed max-w-2xl">
            Founded in the heart of Chittoor at Greamspet, our firm advises
            businesses, growing enterprises and salaried professionals across
            Bengaluru, Chennai, Hyderabad and the rest of India with the same
            standard of care. We believe accounting is less about numbers and
            more about clarity — clarity to act, to plan, and to sleep
            peacefully.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-2xl">
            <div data-testid="about-founder">
              <div className="overline mb-3">Founder</div>
              <div className="font-serif text-2xl text-[#111814] leading-tight">
                CA Roopesh Kumar
              </div>
              <div className="text-sm text-[#68766E] mt-2 tracking-wide">
                ACA · Principal Partner
              </div>
              <p className="text-[#3A453F] mt-4 text-[15px] leading-relaxed">
                An Associate member of the Institute of Chartered Accountants
                of India (ACA) with a focused practice in direct taxation,
                GST and statutory audit for growing businesses.
              </p>
            </div>

            <div data-testid="about-philosophy">
              <div className="overline mb-3">Philosophy</div>
              <div className="font-serif text-2xl text-[#111814] leading-tight">
                Quiet, careful, on time.
              </div>
              <p className="text-[#3A453F] mt-4 text-[15px] leading-relaxed">
                We respect deadlines. We respect detail. Our clients return
                because we treat their books the way we would treat our own —
                with caution and conviction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
